import React from 'react';
import {
  StyleSheet,
  TouchableOpacity,
  View,
  Text,
  Image,
} from 'react-native';
import { FontFamilies } from '@/constants/Typography';

interface ChatButtonProps {
  onPress: () => void;
  notificationCount?: number;
}

export function ChatButton({ onPress, notificationCount = 0 }: ChatButtonProps) {
  return (
    <TouchableOpacity
      style={styles.container}
      onPress={onPress}
      activeOpacity={0.8}
    >
      <View style={styles.buttonWrapper}>
        <Image
          source={require('@/assets/icons/claim-chat.png')}
          style={styles.buttonImage}
          resizeMode="cover"
        />
      </View>
      {notificationCount > 0 && (
        <View style={styles.badge}>
          <Text style={styles.badgeText}>
            {notificationCount > 9 ? '9+' : notificationCount}
          </Text>
        </View>
      )}
    </TouchableOpacity>
  );
}

export default ChatButton;

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 40,
    right: 16,
    zIndex: 1000,
  },
  buttonWrapper: {
    width: 64,
    height: 64,
    borderRadius: 32,
    overflow: 'hidden',
  },
  buttonImage: {
    width: 64,
    height: 64,
  },
  badge: {
    position: 'absolute',
    top: -3,
    right: -2,
    minWidth: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: '#FF3B30',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 4,
  },
  badgeText: {
    color: '#FFFFFF',
    fontSize: 11,
    fontFamily: FontFamilies.Inter.Medium,
    textAlign: 'center',
  },
});
